import { Link, Stack } from '@mui/material';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var UtilityCatalog = function (props) {
    var value = props.value;
    var allowedFeatures = new Set(["ViewOrder", "ShareOrder", "PrintOrder"]);
    var customActionColumns = [{
            field: 'IR Name',
            headerName: 'IR Name',
            align: 'center',
            headerAlign: 'center',
            minWidth: 170
        }, {
            field: 'IR Date',
            headerName: 'IR Date',
            align: 'center',
            headerAlign: 'center',
            minWidth: 150
        }, {
            field: 'Part name & Code',
            headerName: 'Part name & Code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'Defect description & code',
            headerName: 'Defect description & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 210
        }, {
            field: 'Root cause 1',
            headerName: 'Root cause 1',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'Root cause 2',
            headerName: 'Root cause 2',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'Root cause 3',
            headerName: 'Root cause 3',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'CQA correction action 1',
            headerName: 'CQA correction action 1',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            field: 'CQA correction action 2',
            headerName: 'CQA correction action 2',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            field: 'CQA correction action 3',
            headerName: 'CQA correction action 3',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            field: 'ASM Feedback',
            headerName: 'ASM Feedback',
            align: 'center',
            headerAlign: 'center',
            minWidth: 200
        }, {
            field: 'Main defective part name & code',
            headerName: 'Main defective part name & code',
            align: 'center',
            headerAlign: 'center',
            minWidth: 210
        }, {
            field: 'Engineering change request release',
            headerName: 'Engineering change request release',
            align: 'center',
            headerAlign: 'center',
            minWidth: 220
        }, {
            field: 'Process change request release',
            headerName: 'Process change request release',
            align: 'center',
            headerAlign: 'center',
            minWidth: 220
        }, {
            field: 'Cut off VIN no',
            headerName: 'Cut off VIN no',
            align: 'center',
            headerAlign: 'center',
            minWidth: 180
        }, {
            field: 'Cut off date',
            headerName: 'Cut off date',
            align: 'center',
            headerAlign: 'center',
            minWidth: 150
        }, {
            field: 'ECRR date',
            headerName: 'ECRR date',
            align: 'center',
            headerAlign: 'center',
            minWidth: 150
        }, {
            type: 'actions',
            field: '',
            headerName: 'Action',
            renderCell: function () { /*#__PURE__*/ return React.createElement(Link, {
                component: 'button',
                underline: "none"
            }, " Save "); }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: customActionColumns,
        rows: [{
                id: 0
            }, {
                id: 1
            }],
        dataGridProps: {
            disableColumnMenu: false
        }
    })));
};
export default UtilityCatalog;
